'use strict';

(function ($) {
  var methods = {
    init: function () {
      // options are not used
      // var opts = $.extend({}, $.fn.k2_sidebarToggle.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('table-fixed-hover-init')) {
          return;
        }

        $this.addClass('table-fixed-hover-init');

        $this.on('click', '> tbody > tr', function () {
          $this.find('.table-fixed-hover-row').removeClass('table-fixed-hover-row');
          $(this).addClass('table-fixed-hover-row');
        });
      });
    }
  };

  $.fn.k2_tableFixedHover = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_tableFixedHover');
    }
  };

  $.fn.k2_tableFixedHover.defaults = {};

})(jQuery);
